export default Object.freeze({
  PlainText: 'plain-text',
  Html: 'html',
  Markdown: 'markdown',
});
